import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 34.063 34.063",
  "content": "<symbol viewBox=\"0 0 34.063 34.063\" id=\"icon-phone\">\r\n    <path d=\"M14.418,19.647c3.367,3.371,7.273,6.593,8.816,5.05c2.207-2.21,3.571-4.132,8.442-0.218 c4.866,3.914,1.129,6.522-1.013,8.664c-2.469,2.469-11.676,0.129-20.773-8.969C0.789,15.076-1.551,5.869,0.922,3.397 c2.14-2.141,4.75-5.879,8.66-1.008c3.914,4.867,1.992,6.23-0.219,8.441C7.824,12.374,11.047,16.276,14.418,19.647\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/phone.svg
// module id = ./app/general/svg/phone.svg
// module chunks = app